import { CrudState } from "@/store/Crud/State";

export class State extends CrudState {
  baseKnowledgeBook: any = {};
  additionalKnowledgeBookA: any = {};
  additionalKnowledgeBookB: any = {};
  baseHtmlPage = "";
  additionalBookAHtmlPage = "";
  additionalBookBHtmlPage = "";
  pageLoading = false;
}
